<template>
  <div v-if="id" class="message-record-focus">
    <a-alert :type="error?'error':target?.completed?'warning':'info'" show-icon>
      <template #message>{{ error || (target ? `已定位：${target.label || '关联记录'} · ${target.completed?'事件已处理或已流转，请核对当前状态':'请按记录当前状态处理'}` : '正在核对关联记录和访问权限…') }}</template>

    </a-alert>
    <a-button size="small" @click="clear">返回正常列表</a-button>
  </div>
</template>
<script setup lang="ts">
import {computed,ref,watch,onBeforeUnmount} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import request from '@/utils/request'
import store from '@/store'
import {focusedMessageId} from '@/utils/messageRecord'
const route=useRoute(),router=useRouter(),id=computed(()=>focusedMessageId(route.query)),target=ref<any>(null),error=ref('')
let generation=0
watch([()=>route.fullPath,()=>store.getters.token],async()=>{
 const current=++generation;target.value=null;error.value='';if(!id.value)return
 try{const response=await request({url:`order/messages/${id.value}/target`,method:'GET'});if(current!==generation)return;if(response.data?.path!==route.path)throw new Error('该消息与当前功能不匹配，请从全站消息重新进入');target.value=response.data}
 catch(reason:any){if(current===generation)error.value=reason?.message || '关联记录暂不可用，请重新打开消息'}
},{immediate:true})
function clear(){const query={...route.query};for(const key of ['focusMessageId','focusRequestId','focusAuditId','focusAuditState'])delete query[key];void router.replace({path:route.path,query})}
onBeforeUnmount(()=>{generation++})
</script>
<style scoped>.message-record-focus{margin:8px 10px;display:flex;align-items:center;gap:12px}.message-record-focus :deep(.ant-alert){flex:1}.message-record-focus :deep(.ant-alert-action){margin-left:12px}</style>
